/**
 * Type-safe helper for reading environment variables from import.meta.env
 *
 * @param key - The environment variable key (e.g., "VITE_CM_API_BASE_URL")
 * @param defaultValue - Optional default value to return if the env var is not set
 * @returns The environment variable value cast to type T, or defaultValue, or undefined
 *
 * @example
 * ```ts
 * const apiUrl = getEnv("VITE_CM_API_BASE_URL", "http://localhost:5052") // returns string
 * const scope = getEnv("VITE_MSAL_API_SCOPE") // returns string | undefined
 * ```
 */
export function getEnv<T = string>(key: string): T | undefined
export function getEnv<T = string>(key: string, defaultValue: T): T
export function getEnv<T = string>(key: string, defaultValue?: T): T | undefined {
  const value = import.meta.env[key]

  if (value === undefined || value === null || value === "") {
    return defaultValue
  }

  return value as T
}
